type Props = Readonly<{
  url: string;
  color?: string;
  size?: string;
}>;

function SafeGptAlarmIcon({ url, color = 'white', size = '24px' }: Props) {
  return (
    <div
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        maskImage: `url("${url}")`,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskImage: `url("${url}")`,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
      }}
    />
  );
}

export default SafeGptAlarmIcon;
